import React from 'react';

import styled from 'styled-components';

function AbstractRedTextButton(props) {
  const { children } = props;

  return <span {...props}>{children}</span>;
}

export const RedTextButton = styled(AbstractRedTextButton).withConfig({
  displayName: 'RedTextButton',
})`
  color: #be000f;
  font-size: var(--small-size);
  cursor: pointer;
`;
